import { Flow_0_0_2 } from '@flexus/core';

export const SIL_104: Flow_0_0_2 = {
	id: '104',
	name: 'assessor_job_done',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
